import { GET_PACKAGE_SETTING } from "../actions/types";

const initialState = {
  getpackageData: [],
};

const packageSettingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_PACKAGE_SETTING:
      return {
        ...state,
        getpackageData: payload,
      };
    default:
      return state;
  }
};

export { packageSettingReducer };
